import React, { Component } from 'react'
import { ModalBody, Modal, Row, Col } from "react-bootstrap";
import InputMask from "react-input-mask";
import { Button } from '../../common';
import { post } from './../../../utility/apiClient';
import { errorTypesEnum } from './../../../utility/enums';
import './ageGate.scss'
/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { updateAgeVerification } from '../../../redux/actions/ageVerificationActions';
import { resetAgeGate } from '../../../redux/actions/ageGateActions';
import { showLoadingScreen, hideLoadingScreen } from '../../../redux/actions/loadingScreenActions';
import { showMessageBox, resetMessageBox } from '../../../redux/actions/messageBoxActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        systemConfiguration: state.webDataCollection.systemConfiguration,
        ageGate: state.ageGate,
        userDetails: state.userDetails
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    updateAgeVerification,
    resetAgeGate,
    showLoadingScreen,
    hideLoadingScreen,
    showMessageBox,
    resetMessageBox
};

class AgeGate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            DOB: "",
            DOBError: "",
            agreeTC: false,
            agreeTCError: ""
        }
        this.handleCallBackFunction = this.handleCallBackFunction.bind(this);
    };

    handleDateChange(e) {
        this.setState({
            DOB: e.target.value
        })
        if (e.target.value) {
            this.setState({
                DOBError: ""
            })
        }
    }

    validateDOB() {
        let isValid = true;
        let dateArr = this.state.DOB.split("/")
        let day = dateArr[0];
        let month = dateArr[1];
        let year = dateArr[2];
        let castedDate = new Date(Date.parse(year + "-" + month + "-" + day + "T00:00:00.000Z"))
        if (!castedDate.getDate()) {
            isValid = false;
            this.setState({
                DOBError: "Please enter a valid date"
            })
        } else {
            if (castedDate > new Date()) {
                isValid = false;
                this.setState({
                    DOBError: "Please enter a valid date"
                })
            }
        }
        if (!this.state.agreeTC) {
            isValid = false;
            this.setState({
                agreeTCError: "You must agree to the terms & conditions"
            })
        }
        return isValid;
    }

    submit() {
        if (this.validateDOB()) {
            let DOB = null;
            let dateArr = this.state.DOB.split("/")
            let day = dateArr[0];
            let month = dateArr[1];
            let year = dateArr[2];
            DOB = new Date(Date.parse(year + "-" + month + "-" + day + "T00:00:00.000Z"))
            //let age = new Date().getFullYear() - DOB.getFullYear();
            let age = new Date(new Date() - DOB).getFullYear() - 1970;
            let ageVerification = {
                isLegalAge: false,
                attemptedVerification: true
            }
            if (age >= this.props.systemConfiguration.legalAgeLimit) {
                ageVerification = {
                    isLegalAge: true,
                    attemptedVerification: true
                }
            }
            this.logAttempt(DOB, ageVerification);
        }
    }

    logAttempt(DOB, ageVerification) {
        this.props.showLoadingScreen();
        let body = {
            customerID: this.props.userDetails.customerID,
            DOB: DOB
        }
        post("/web/LogAgeConsent", body).then(response => {
            if (response.data.statusCode == 200) {
                this.props.updateAgeVerification(ageVerification);
                this.handleCallBackFunction(ageVerification.isLegalAge);
            } else {
                let errorType = response.data.errorList[0].errorType;
                let messageBox = {
                    show: true,
                    title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                    className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                this.props.showMessageBox(messageBox);
            }
            this.props.hideLoadingScreen();
        })
    }

    handleCallBackFunction(response) {
        if (this.props.ageGate.callBackFunction != null) {
            // this.props.resetAgeGate();
            this.props.ageGate.callBackFunction(response);
        } else {
            this.props.resetAgeGate();
        }
    };

    redirect() {
        this.props.resetAgeGate().then(() => window.location.href = "/TermsAndConditions");
    }

    render() {
        //props
        const { show, isPage } = this.props.ageGate;

        return (
            <React.Fragment>
                <Modal size="md" centered className="popup-box" show={show ?? false}>
                    <ModalBody>
                        <div className="content-holder">
                            <Row className="text-center">
                                <Col>
                                    <div className='age-gate-close-btn' onClick={() => { this.props.resetAgeGate(); }}>X</div>
                                </Col>
                                <Col md="12">
                                    {isPage ?
                                        <div className="form-group age-gate-text">
                                            You must be {this.props.systemConfiguration.legalAgeLimit} years or older to enter this page. Please enter your date of birth.
                                        </div>
                                        :
                                        <div className="form-group age-gate-text">
                                            You must be {this.props.systemConfiguration.legalAgeLimit} years or older to purchase this product. Please enter your date of birth.
                                        </div>
                                    }

                                </Col>
                                <Col md="12">
                                    <Col md="auto">
                                        <div className="form-group">
                                            <InputMask id="DOB" name="DOB" mask="99/99/9999" placeholder="dd/mm/yyyy" className="form-control" value={this.state.DOB} onChange={(e) => this.handleDateChange(e)} />
                                            <span className="age-gate-error-span">{this.state.DOBError}</span>
                                        </div>
                                    </Col>
                                </Col>
                                {this.props.systemConfiguration.ageConsentMessage ?
                                    <Col md="12">
                                        <div className="form-group">
                                            {this.props.systemConfiguration.ageConsentMessage}
                                        </div>
                                    </Col>
                                    : null}
                                <Col md="12">
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox">
                                            <input name="checkbox" id="is_default" type="checkbox" className="custom-control-input" value="save_as_template"
                                                onChange={(e) => { this.setState({ agreeTC: e.target.checked, agreeTCError: "" }) }}
                                                checked={this.state.agreeTC} />
                                            <label htmlFor="is_default" className="custom-control-label white">I agree to the <a className="age-gate-link" target="_blank" href="/mobtc">Terms and Conditions</a></label>
                                        </div>
                                        <span className="age-gate-error-span">{this.state.agreeTCError}</span>
                                    </div>
                                </Col>
                                <Col md="12">
                                    <Button primary onClick={() => this.submit()}>Submit</Button>
                                </Col>
                            </Row>
                        </div>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgeGate);
